//@ts-nocheck
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { CSS } from "src/_utils/styles";
import { Btn, Image } from "src/AbstractElements";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import { remotePath } from "src/base/settings/Paths";
import { Session } from "src/base/store/authSlice";
import { ReduxDataKey } from "src/base/store/store";
import { FormComponent, FormDescription, FormLangs, SentFormFeedback } from "./FormCommon";
import { Layout } from "src/base/store/layoutSlice";

const FormPublicPage = ({ formSlug }: any) => {
  const { trans } = useEBSSSLayout();
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);
  const { form, appSettings, fetchForm, sendForm } = useEBSSS();
  const [sentForm, setSentForm] = useState(false);
  const getForm = useParams();
  const navigate = useNavigate();

  console.log("FORM: ", form);
  console.log("APPSETTINGS: ", appSettings);

  useEffect(() => {
    fetchForm(formSlug ? formSlug : getForm?.slug, ebsssLayout?.activeLanguage, !!formSlug);
  }, []);

  return formSlug ? (
    !sentForm ? (
      <CardBody>
        <div className="d-flex flex-row justify-content-between align-items-top">
          <FormDescription description={form?.form?.description} />
          <FormLangs availableLanguages={form?.available_languages} trans={trans} fetcher={(lang) => fetchForm(getForm?.slug, lang)} />
        </div>
        <FormComponent
          form={form}
          authUser={sessionNow?.user}
          sendForm={sendForm}
          trans={trans}
          appSettings={appSettings}
          setSentForm={setSentForm}
          formSlug={formSlug}
        />
      </CardBody>
    ) : (
      <CardBody>
        <SentFormFeedback trans={trans} authUser={sessionNow?.user} />
      </CardBody>
    )
  ) : (
    <div
      style={CSS({
        backgroundImage: `url(${remotePath.assetsUrl(appSettings?.background)})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        minHeight: "100vh",
        height: "100%",
      })}
    >
      <Card
        style={CSS({
          background: "#00000000",
          marginBottom: 0,
        })}
      >
        <div className="container my-5 justify-content-center">
          <div className="col-12 row">
            <div className="col-12 col-md-3">
              <div className="w-100">
                <div
                  className="rounded align-items-center justify-content-center w-100 m-auto p-lg-3 p-4 text-dark"
                  style={CSS({ backgroundColor: "#ffffff8f" })}
                >
                  <div className="d-flex flex-column justify-content-center align-items-center gap-3">
                    {appSettings?.logo ? (
                      <Image
                        attrImage={{
                          style: CSS({ cursor: "pointer" }),
                          onClick: () => navigate(process.env.PUBLIC_URL),
                          className: "m-auto d-flex align-self-center",
                          src: remotePath.assetsUrl(appSettings?.logo),
                          alt: "logo",
                          width: "50%",
                          height: "100%",
                        }}
                      />
                    ) : (
                      <h1>{appSettings?.instance_title}</h1>
                    )}
                    <FormLangs availableLanguages={form?.available_languages} trans={trans} fetcher={(lang) => fetchForm(getForm?.slug, lang)} />
                    <h1 className="text-center">{form?.form?.title}</h1>
                    <div className={`d-flex flex-column gap-3 p-2 justify-content-center`}>
                      {appSettings?.hidden_faq === 0 ? (
                        <Btn>
                          <Link to={process.env.PUBLIC_URL + "/faq"} className="bottom-left">
                            <i className="me-1 fa fa-question-circle" />
                            {trans("website.faq-link")}
                          </Link>
                        </Btn>
                      ) : (
                        <></>
                      )}
                      {appSettings?.crm_customer_area ? (
                        <Btn attrBtn={{ color: "light" }}>
                          {!sessionNow.user || sessionNow?.user?.status === "guest" ? (
                            <Link to={process.env.PUBLIC_URL + "/auth/sign-in"} className="bottom-right">
                              <i className="me-1 fa fa-lock" />
                              {trans("website.sign-in-link")}
                            </Link>
                          ) : (
                            <Link to={process.env.PUBLIC_URL + "/dashboard"} className="bottom-right">
                              <i className="me-1 fa fa-user" />
                              {trans("website.customer_area")}
                            </Link>
                          )}
                        </Btn>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-9">
              {!sentForm ? (
                <div className="w-100">
                  <div className="rounded w-100 m-auto p-lg-3 p-4 text-dark" style={CSS({ backgroundColor: "#ffffff8f" })}>
                    <br />
                    <div className="d-flex flex-row justify-content-between align-items-top">
                      <FormDescription description={form?.form?.description} />
                    </div>
                    <FormComponent
                      form={form}
                      authUser={sessionNow?.user}
                      sendForm={sendForm}
                      trans={trans}
                      appSettings={appSettings}
                      setSentForm={setSentForm}
                    />
                  </div>
                </div>
              ) : (
                <CardBody>
                  <SentFormFeedback trans={trans} authUser={sessionNow?.user} />
                </CardBody>
              )}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FormPublicPage;
